
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import CommandButton from './CommandButton';

const classNames = mergeStyleSets({
    toolbar: {
    }
});

const ToolbarCommandButton = (props) => {

    const horizontalAlign = props.horizontalAlign || 'end';

    return (
        <Stack
            horizontal
            horizontalAlign={horizontalAlign}
            className={classNames.toolbar}
        >
            {props.items.map((item, index) => {
                return (
                    <CommandButton
                        key={index}
                        onClick={item.onClick}
                        text={item.text}
                        title={item.title}
                        disabled={item.disabled}
                        icon={item.icon}
                        styles={item.styles}
                    />
                );
            })}
        </Stack>
    )
}

export default ToolbarCommandButton;
